<template>
    <div id="test6">
        <el-button @click="addstore">输出表格</el-button>
        <vxe-toolbar ref="toolbarRef" custom></vxe-toolbar>
        <vxe-table id="1111" size="mini" :edit-config="editConfig" :data="tableData" border :column-config="{resizable:true}"  :columns="columns"  stripe   width="100%"
            :custom-config="customConfig" ref="tableRef">
            <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title" :edit-render="{name: 'input'}"></vxe-column>
        </vxe-table>
    </div>
</template>
<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'test6',
    mixins: [userProfile],
    //组件创建
    created() {
        this.loadTableData();
    },
    mounrted() {
    },
    data() {
        return {
            tableData: [],
            columns: [],
            editConfig:{
                trigger: 'click',
                mode: 'cell'
            }
        }
    },
    methods: {
        // 加载表格数据和列配置
        loadTableData() {
            const URL = `${url.getDynamicTable}`;
            req.get(URL).then((res) => {
                if (res.data.code === 200) {
                    this.columns = res.data.data.columns; // 动态列配置
                    this.tableData = res.data.data.tableData; // 表格数据
                } else {
                    VxeUI.modal.message({
                        status: "error",
                        content: "加载表格数据失败",
                    });
                }
            });
        },
        addstore(){
        },
    }
}
</script>
<style lang="less" scoped></style>